import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import { GetOrganizerUser } from "../../utils/api";
import { useLanguage } from "../../hooks/useLanguage";
import { useOrder } from "../../hooks/useOrder";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Loading from "../components/Loading";

const PasswordReset = () => {
    const [username, setUsername] = useState('');

    const [resources, setResources] = useState({});
    const { language } = useLanguage();

    const { redirectUrl } = useParams();

    const [isInputHidden, setIsInputHidden] = useState(false);
    const [formError, setFormError] = useState("");
    const [formSuccess, setFormSuccess] = useState("");

    const navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const order = useOrder(baseUrl);

    useEffect(() => {
        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            localStorage.setItem("token", res.data);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const isValidEmail = (email) => {
        // Simple regex for email validation
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handlePasswordReset = async (e) => {
        setFormSuccess("");
        setFormError("");
        e.preventDefault();

        if (!isValidEmail(username)) {
            setFormError(resources?.ErrorEmailNotValid);
            return;
        }

        setIsInputHidden(true);

        try {

            // after password is reset the user will be redirect to the account-login page
            const returnUrl = window.location.origin + `/${language}/${redirectUrl}/success`;

            const res = await axios.post('/form/passwordreset', {
                Username: username,
                ReturnUrl: returnUrl
            });

            setFormSuccess(resources?.Account_PasswordResetConfirmation);
        } catch (err) {
            if (err.response.status === 404) {
                setFormSuccess(resources?.Account_PasswordResetConfirmation);
            } else {
                setFormError(resources?.Account_PasswordResetError)
            }
            console.error('Password reset failed:', err.response?.data || err.message);
        }
    };

    return (
        <>
            <Header language={language} pagePath="password-reset" pageTitle={resources?.Account_PasswordReset}
                ticketCount={order?.tickets?.length || 0} />

            <div className="page-container">

                <div className="container wrapper">

                    {/* inputs */}
                    <form onSubmit={handlePasswordReset}>

                        {!isInputHidden &&
                            <>
                                <div className="row mb-4">
                                    <div className="col-md-12 d-flex flex-column">
                                        <span>{resources?.Account_PasswordResetDesc}</span>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="staticEmail" className="col-sm-3 col-form-label">{resources?.BuyerEmail}</label>
                                    <div className="col-sm-9">
                                        <input
                                            className="form-control"
                                            name="username"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </>
                        }


                        {formError &&
                            <div className="row text-start mt-2">
                                <p className="text-red">{formError}</p>
                            </div>
                        }

                        {formSuccess &&
                            <div className="row text-start mt-2">
                                <p className="text-red">{formSuccess}</p>
                            </div>
                        }

                        {/* buttons */}
                        <div className="row mt-5">
                            <div className="col-6">
                                <button
                                    className="btn-custom white"
                                    onClick={() => navigate(-1)}
                                >
                                    {resources?._Back}
                                </button>
                            </div>

                            {!isInputHidden &&
                                <div className="col-6 text-end">
                                    <button
                                        className="btn-custom"
                                        type="submit"
                                    >
                                        {resources?._Submit}
                                    </button>
                                </div>
                            }
                        </div>
                    </form>

                </div>

            </div>

            <Footer language={language} />
        </>
    )
}

export default PasswordReset